import { replaceTemplate } from './templating';

export const override_lookup = {
  alert_status: {
    ACTIVE: 'Active',
    __GRAY__: 'Under Contract',
    SOLD: 'Sold',
  },
};

type Creative = {
  creative_text: string;
  key_values: Record<string, string>;
  lookup: object;
  override_lookup: Record<string, Record<string, string>>;
};

/**
 * This is used in search, area, property, collage, and multi ads in order to
 * replace the template text in the main and sub creatives with the
 * property/search values retrieved by `analyze_link`
 *
 * @param creative_text - The text with templated values. This is the
 * 'blueprint' that contains template values to be replaced
 * @param key_values - Primary key-value pairs in criteria. Things such as 'baths', 'average_baths', 'beds', etc. will be in here
 * @param lookup - Typically a object filled with property types from mcp. Used in search, area, and multi
 */
export async function renderCreative({
  creative_text,
  key_values,
  lookup,
  override_lookup: overrideLookup,
}: Creative) {
  const subbedPromise = replaceTemplate(
    creative_text,
    key_values,
    lookup,
    overrideLookup,
    false,
  );

  const markedupPromise = replaceTemplate(
    creative_text,
    key_values,
    lookup,
    overrideLookup,
    true,
  );

  const [subbed, markedup] = await Promise.all([subbedPromise, markedupPromise]);

  return {
    template: creative_text,
    subbed,
    markedup,
  };
}
